const selectedServices = [
  {
    id: 1,
    service: 'Wash and Fold',
    quantity: 0,
    price: 86.5,
  },
  {
    id: 2,
    service: 'Dry Cleaning',
    quantity: 0,
    price: 26.5,
  },
  {
    id: 3,
    service: 'Ironing',
    quantity: 0,
    price: 36.5,
  },
  {
    id: 4,
    service: 'Wash and Fold',
    quantity: 0,
    price: 4.5,
  },
  {
    id: 5,
    service: 'Dry Cleaning',
    quantity: 0,
    price: 44.5,
  },
  {
    id: 6,
    service: 'Ironing',
    quantity: 0,
    price: 22.5,
  },
];

const phoneTypes = [
  {
    id: 0,
    value: 'MOBILE',
    displayValue: 'Mobile',
  },
  {
    id: 1,
    value: 'LANDLINE',
    displayValue: 'Landline',
  },
];

const preferencesData = {
  products: [
    { id: 0, value: 'No Preference', label: 'No Preference', default: true },
    {
      id: 1,
      value: 'Standard',
      label: 'Standard',
      default: false,
    },
    {
      id: 2,
      value: 'Free & Clear',
      label: 'Free & Clear',
      default: false,
    },
  ],
  wash_temp: [
    {
      id: 0,
      value: 'No Preference',
      label: 'No Preference',
      default: true,
    },
    { id: 1, value: 'Hot', label: 'Hot', default: false },
    { id: 2, value: 'Warm', label: 'Warm', default: false },
    { id: 3, value: 'Cold', label: 'Cold', default: false },
  ],
  dryer_heat: [
    { id: 0, value: 'No Preference', label: 'No Preference', default: true },
    { id: 1, value: 'High Heat', label: 'High Heat', default: false },
    { id: 2, value: 'Regular / Medium Heat', label: 'Regular / Medium Heat', default: false },
  ],
  pickup_delivery: [
    { id: 0, value: 'Front Door / Entrance', label: 'Front Door / Entrance', default: true },
    { id: 1, value: 'In-person Handoff', label: 'In-person Handoff', default: false },
    { id: 2, value: 'Front Desk / Reception', label: 'Front Desk / Reception', default: false },
    { id: 3, value: 'Other', label: 'Other', default: false },
  ],
  other_details: '',
};

export { selectedServices, phoneTypes, preferencesData };
